import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { getApplicationSpaBackendUrl } from "@utils";
import { httpHeaders } from "@shared/constants/httpHeaders";

import { type IBifrostFile, type IBifrostFileMagicLinkUploadInput } from "@types";

export const bifrostFilesMagicLinkApiReducerKey = "bifrostFilesMagicLinkApi";

export const bifrostFilesMagicLinkApi = createApi({
  reducerPath: bifrostFilesMagicLinkApiReducerKey,
  baseQuery: fetchBaseQuery({ baseUrl: getApplicationSpaBackendUrl() }),
  endpoints: (builder) => ({
    postBifrostFileMagicLink: builder.mutation<IBifrostFile, IBifrostFileMagicLinkUploadInput>({
      query: ({ token, file, metadata }) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("metadata", JSON.stringify(metadata));

        return {
          url: "/bifrost-files-magic-link",
          method: "POST",
          body: formData,
          headers: { [httpHeaders.magicToken]: token },
        };
      },
    }),
  }),
});

export const { usePostBifrostFileMagicLinkMutation } = bifrostFilesMagicLinkApi;
